import { render, staticRenderFns } from "./LocationShipperNotifications.vue?vue&type=template&id=cfe94204&scoped=true&"
import script from "./LocationShipperNotifications.vue?vue&type=script&lang=js&"
export * from "./LocationShipperNotifications.vue?vue&type=script&lang=js&"
import style0 from "./LocationShipperNotifications.vue?vue&type=style&index=0&id=cfe94204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe94204",
  null
  
)

export default component.exports